import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp, FaHeadset, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import '../../styles/faq.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    // If clicking the same item, close it. Otherwise open the new one
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What are the qualifications required to do the course?",
      answer: "If you have completed or continuing B.Tech, M.Tech, MCA, BCA, B.Sc, M.Sc or Any Graduation. You can easily do this course and start your career as a Software Developer."
    },
    {
      question: "Does your institute provide 100% Placement Guarantee?",
      answer: "No, we do not make any fraudulent offers about placements to make you join the course. In fact, we guarantee 100% subject as per realtime standards so you will be ready for the job after completing our course."
    },
    {
      question: "Do you provide placement assistance?",
      answer: "Yes, we are one of the oldest & trusted software training institute in Bhilai and will help with genuine placement assistance in good companies. We will provide you reference only to Durg-Bhilai-Raipur location software companies. Based on your performance you can get a job."
    },
    {
      question: "Is there any project supported with the course?",
      answer: "Yes, after the completion of the course. the instructor will allot you a real-time project to have a clear understanding of how you are able to conceptualize and implement the real-world application of the course content."
    },
    {
      question: "Does Sensible Academy provide Hostel/PG Facility?",
      answer: "No. We do not provide Hostel or PG facility. But there are many PG's and Hostels very nearby to our training center. You can Google for nearby PG's and Hostels in Smriti Nagar, Bhilai, you will get a wide range of reputed and decent PG's & Hostels."
    },
    {
      question: "What are the profiles and experiences of trainers at Sensible Academy?",
      answer: "We have a strong team of professionals having expert knowledge in their fields. Our trainers are very supportive and render friendly working environment to the students which stimulate their growth in a positive manner. They all are with huge industrial and teaching experiences."
    },
    {
      question: "What if I have doubts/queries before or after the session?",
      answer: "If you have doubts before the class, you can post your queries in the discussion forum or face-to-face during the session. If you have any doubts after the session is over, then you can email the instructors. We assure you that the instructor will respond back to your query on an immediate basis."
    },
    {
      question: "Sensible Academy is a software development company or training institute?",
      answer: "Sensible Computers is a complete Custom Software Development and Web Design Company in Bhilai, also providing software courses like JAVA, PYTHON, .NET, PHP, Website Designing, Internship training to B.Tech, MCA, B.Sc, M.Sc. Students, which is a part of their Graduate/Post Graduate Degree under brand name of Sensible Academy."
    }
  ];

  return (
    <section className="faq-sections">
      <Container>
        <div className="faq-headers text-center">
          <h2 className="faq-titles">
            Frequently Asked <span className="text-primary">Questions</span>
          </h2>
          <p className="faq-subtitles">
            Find answers to common questions about our courses and training programs
          </p>
        </div>

        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="faq-containers">
              {faqs.map((faq, index) => (
                <div 
                  key={index} 
                  className={`faq-items ${openIndex === index ? 'active' : ''}`}
                >
                  <div 
                    className="faq-questions"
                    onClick={() => toggleFaq(index)}
                  >
                    <div className="faq-question-lefts">
                      <span className="faq-numbers">{String(index + 1).padStart(2, '0')}</span>
                      <h4>{faq.question}</h4>
                    </div>
                    <div className="faq-icons">
                      {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  </div>
                  <div className="faq-answers">
                    <div className="faq-answer-contents">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Still Have Questions Section */}
            <div className="faq-contacts">
              <div className="contact-cards">
                <div className="contact-icons">
                  <FaHeadset />
                </div>
                <h4>Still Have Questions?</h4>
                <p>Can't find the answer you're looking for? Please contact our support team.</p>
                <div className="contact-linkss">
                  <a href="mailto:contact@sensibleacademy.com" className="contact-links">
                    <FaEnvelope />contact@sensibleacademy.com
                  </a>
                  <a href="tel:+917722899444" className="contact-links">
                    <FaPhoneAlt /> +91 77228-99444 | +91 93013-51989
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQ;